import { makeStyles } from "@material-ui/core";
import { darkGrey } from "../../../theme";

export const MemberNotificationStyles = makeStyles(theme => ({
  hidden: {
    position: "absolute",
    opacity: "0",
  },
  messageContainer: {
    userSelect: "none",
    position: "static",
    opacity: "1",
    backgroundColor: darkGrey,
    "&:hover": {
      backgroundColor: darkGrey,
      transition: "background-color 0.1s ease",
    },
    transition: "opacity 0.5s linear, background-color 0.1s ease",
  },
  textLayout: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  iconPosition: {
    marginRight: "5px",
  },
}));
